/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CancelCampaignResponse interface.
 */
export function instanceOfCancelCampaignResponse(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function CancelCampaignResponseFromJSON(json) {
    return CancelCampaignResponseFromJSONTyped(json, false);
}
export function CancelCampaignResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
    };
}
export function CancelCampaignResponseToJSON(json) {
    return CancelCampaignResponseToJSONTyped(json, false);
}
export function CancelCampaignResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
    };
}
